<div class="eventq-action-form" [attr.aria-busy]="loading() ? 'true' : 'false'">
  @if (loading() && !hasActionableList()) {
    <div class="eventq-action-form__skeleton" aria-hidden="true">
      <div class="eventq-action-form__skeleton-row">
        <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--field"></div>
        <div
          class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--field eventq-action-form__skeleton-block--narrow"
        ></div>
      </div>
      <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--dropzone"></div>
      <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--card"></div>
      <div class="eventq-action-form__skeleton-row">
        <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--field"></div>
        <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--field"></div>
      </div>
      <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--textarea"></div>
      <div class="eventq-action-form__skeleton-actions">
        <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--button"></div>
        <div class="eventq-action-form__skeleton-block eventq-action-form__skeleton-block--button"></div>
      </div>
    </div>
  } @else {
    @for (section of sections(); track $index) {
      @switch (section.type) {
        @case ('row') {
          <div class="eventq-action-form__row">
            @for (field of section.fields; track field.key) {
              <div class="eventq-action-form__field" [style]="fieldWidthStyle(field)">
                @switch (field.type) {
                  @case ('select') {
                    <eventq-select
                      [options]="field.options"
                      [value]="selectValue(field.key)"
                      [label]="field.label"
                      [placeholder]="field.placeholder ?? 'Select'"
                      [requiredIndicator]="!!field.required"
                      [validateRequired]="!!field.required"
                      [submitAttempted]="isSubmitAttempted()"
                      [invalid]="!!field.invalid"
                      [tone]="field.tone ?? 'default'"
                      [disabled]="isSelectDisabled(field)"
                      (valueChange)="onFieldValueChange(field.key, $event)"
                    />
                  }
                  @case ('text') {
                    <eventq-input
                      [label]="field.label"
                      [placeholder]="field.placeholder ?? ''"
                      [requiredIndicator]="!!field.required"
                      [validateRequired]="!!field.required"
                      [submitAttempted]="isSubmitAttempted()"
                      [value]="stringValue(field.key)"
                      [disabled]="isFieldDisabled(field)"
                      (valueChange)="onFieldValueChange(field.key, $event)"
                    />
                  }
                  @case ('textarea') {
                    <eventq-input
                      [label]="field.label"
                      [placeholder]="field.placeholder ?? ''"
                      [multiline]="true"
                      [rows]="field.rows ?? 1"
                      [requiredIndicator]="!!field.required"
                      [validateRequired]="!!field.required"
                      [submitAttempted]="isSubmitAttempted()"
                      [value]="stringValue(field.key)"
                      [disabled]="isFieldDisabled(field)"
                      (valueChange)="onFieldValueChange(field.key, $event)"
                    />
                  }
                  @case ('datetime') {
                    <eventq-datetime-picker
                      mode="field"
                      panelPlacement="below"
                      [fieldLabel]="field.label"
                      [fieldPlaceholder]="field.placeholder ?? ''"
                      [required]="!!field.required"
                      [value]="dateValue(field.key)"
                      [disabled]="isFieldDisabled(field)"
                      (applied)="onDatetimeApplied(field.key, $event)"
                    />
                  }
                }
              </div>
            }
          </div>
        }
        @case ('dropzone') {
          <eventq-file-dropzone
            [label]="section.label"
            [hint]="section.hint ?? null"
            [accept]="section.accept ?? null"
            [multiple]="section.multiple ?? true"
            [disabled]="readonly()"
            [files]="filesValue(section.key)"
            (filesChange)="onFilesSelectedForKey(section.key, $event)"
          />
        }
        @case ('actionableList') {
          <eventq-actionable-list
            [appearance]="section.appearance ?? 'popover'"
            [items]="listItems(section)"
            [searchQuery]="listSearchQuery(section)"
            [showSearch]="section.showSearch ?? true"
            [activateLabel]="section.activateLabel ?? 'Activate'"
            [listHeight]="section.listHeight ?? null"
            [listAriaLabel]="section.listAriaLabel ?? 'Actionable items'"
            [loading]="loading() || (section.loading ?? false)"
            [skeletonCount]="section.skeletonCount ?? null"
            [disabled]="readonly() || (section.disabled ?? false)"
            [activateOptions]="activateOptions()"
            (searchQueryChange)="onListSearchChange(section, $event)"
            (activate)="onListActivate(section, $event)"
            (info)="onListInfo(section, $event)"
          />
        }
        @case ('infoCard') {
          <eventq-info-card
            [tone]="section.tone ?? 'neutral'"
            [category]="section.category ?? ''"
            [title]="section.title"
            [meta]="section.meta ?? []"
            [notes]="section.notes ?? []"
            [note]="section.note ?? null"
          />
        }
        @case ('actions') {
          <div class="eventq-action-form__actions">
            @for (item of section.actions; track item.id) {
              <eventq-button
                [label]="item.label"
                [variant]="actionVariant(item.variant)"
                size="sm"
                [disabled]="readonly()"
                (pressed)="onActionPressed(item.id, item.validates, sections())"
              />
            }
          </div>
        }
        @case ('group') {
          <div
            class="eventq-action-form__group"
            [attr.data-group-id]="section.id"
            [attr.data-group-locked]="isGroupInteractive(section.id) ? null : 'true'"
          >
            @for (groupSection of section.sections; track $index) {
              @switch (groupSection.type) {
                @case ('row') {
                  <div class="eventq-action-form__row">
                    @for (field of groupSection.fields; track field.key) {
                      <div class="eventq-action-form__field" [style]="fieldWidthStyle(field)">
                        @switch (field.type) {
                          @case ('select') {
                            <eventq-select
                              [options]="field.options"
                              [value]="selectValue(field.key)"
                              [label]="field.label"
                              [placeholder]="field.placeholder ?? 'Select'"
                              [requiredIndicator]="!!field.required"
                              [validateRequired]="!!field.required"
                              [submitAttempted]="isSubmitAttempted(section.id)"
                              [invalid]="!!field.invalid"
                              [tone]="field.tone ?? 'default'"
                              [disabled]="isSelectDisabled(field, section.id)"
                              (valueChange)="onFieldValueChange(field.key, $event, section.id)"
                            />
                          }
                          @case ('text') {
                            <eventq-input
                              [label]="field.label"
                              [placeholder]="field.placeholder ?? ''"
                              [requiredIndicator]="!!field.required"
                              [validateRequired]="!!field.required"
                              [submitAttempted]="isSubmitAttempted(section.id)"
                              [value]="stringValue(field.key)"
                              [disabled]="isFieldDisabled(field, section.id)"
                              (valueChange)="onFieldValueChange(field.key, $event, section.id)"
                            />
                          }
                          @case ('textarea') {
                            <eventq-input
                              [label]="field.label"
                              [placeholder]="field.placeholder ?? ''"
                              [multiline]="true"
                              [rows]="field.rows ?? 1"
                              [requiredIndicator]="!!field.required"
                              [validateRequired]="!!field.required"
                              [submitAttempted]="isSubmitAttempted(section.id)"
                              [value]="stringValue(field.key)"
                              [disabled]="isFieldDisabled(field, section.id)"
                              (valueChange)="onFieldValueChange(field.key, $event, section.id)"
                            />
                          }
                          @case ('datetime') {
                            <eventq-datetime-picker
                              mode="field"
                              panelPlacement="below"
                              [fieldLabel]="field.label"
                              [fieldPlaceholder]="field.placeholder ?? ''"
                              [required]="!!field.required"
                              [value]="dateValue(field.key)"
                              [disabled]="isFieldDisabled(field, section.id)"
                              (applied)="onDatetimeApplied(field.key, $event, section.id)"
                            />
                          }
                        }
                      </div>
                    }
                  </div>
                }
                @case ('dropzone') {
                  <eventq-file-dropzone
                    [label]="groupSection.label"
                    [hint]="groupSection.hint ?? null"
                    [accept]="groupSection.accept ?? null"
                    [multiple]="groupSection.multiple ?? true"
                    [disabled]="!isGroupInteractive(section.id)"
                    [files]="filesValue(groupSection.key)"
                    (filesChange)="onFilesSelectedForKey(groupSection.key, $event, section.id)"
                  />
                }
                @case ('actionableList') {
                  <eventq-actionable-list
                    [appearance]="groupSection.appearance ?? 'popover'"
                    [items]="listItems(groupSection)"
                    [searchQuery]="listSearchQuery(groupSection)"
                    [showSearch]="groupSection.showSearch ?? true"
                    [activateLabel]="groupSection.activateLabel ?? 'Activate'"
                    [listHeight]="groupSection.listHeight ?? null"
                    [listAriaLabel]="groupSection.listAriaLabel ?? 'Actionable items'"
                    [loading]="loading() || (groupSection.loading ?? false)"
                    [skeletonCount]="groupSection.skeletonCount ?? null"
                    [disabled]="!isGroupInteractive(section.id) || (groupSection.disabled ?? false)"
                    [activateOptions]="activateOptions()"
                    (searchQueryChange)="onListSearchChange(groupSection, $event, section.id)"
                    (activate)="onListActivate(groupSection, $event, section.id)"
                    (info)="onListInfo(groupSection, $event, section.id)"
                  />
                }
                @case ('infoCard') {
                  <eventq-info-card
                    [tone]="groupSection.tone ?? 'neutral'"
                    [category]="groupSection.category ?? ''"
                    [title]="groupSection.title"
                    [meta]="groupSection.meta ?? []"
                    [notes]="groupSection.notes ?? []"
                    [note]="groupSection.note ?? null"
                  />
                }
                @case ('actions') {
                  <div class="eventq-action-form__actions">
                    @for (item of groupSection.actions; track item.id) {
                      <eventq-button
                        [label]="item.label"
                        [variant]="actionVariant(item.variant)"
                        size="sm"
                        [disabled]="!isGroupInteractive(section.id)"
                        (pressed)="
                          onActionPressed(item.id, item.validates, section.sections, section.id)
                        "
                      />
                    }
                  </div>
                }
              }
            }
            @if (inlineSubmit()) {
              <eventq-resolve-submit
                [submitted]="isGroupSubmitted(section.id)"
                [submittedAt]="groupSubmittedAt(section.id)"
                [submitDisabled]="isGroupSubmitDisabled(section)"
                (submit)="onActionPressed('submit', true, section.sections, section.id)"
              />
            }
          </div>
        }
      }
    }
    @if (inlineSubmit() && !hasGroups()) {
      <eventq-resolve-submit
        [submitted]="submitted()"
        [submittedAt]="submittedAt()"
        [submitDisabled]="isRootSubmitDisabled()"
        (submit)="onActionPressed('submit', true, sections())"
      />
    }
  }
</div>
